import React, { useMemo, useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useBoxesUIContext } from '../BoxesUIContext';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import { boxStatusList } from '../BoxesUIHelpers';

const PARAM_URL = '/params';
const prepareFilter = (queryParams, values) => {
  const { from, to, websiteCode, searchText, status } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  filter.status = status !== '' ? status : undefined;
  filter.websiteCode = websiteCode !== '' ? websiteCode : undefined;

  //console.log("from=" + from);
  filter.from = from; // : new Date().toISOString().slice(0, 10);
  //console.log("to=" + to);
  filter.to = to; // !== "" ? +to : new Date().toISOString().slice(0, 10);//to !== "" ? +to : Date.now();

  // Filter by all fields
  //console.log("searchText=" + searchText);
  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;
  //console.log('filter=', newQueryParams.filter);
  return newQueryParams;
};

const BoxesFilter = (props) => {
  /*  const { intl } = props;
   const typeOptionAll = intl.formatMessage({ id: 'ORDER.QRCODETYPE.ALL' }); */

  const [loaded, setLoaded] = useState(false);
  const [websiteList, setWebsiteList] = useState([]);
  const BoxesUIContext = useBoxesUIContext();
  const BoxesUIProps = useMemo(() => {
    return {
      queryParams: BoxesUIContext.queryParams,
      setQueryParams: BoxesUIContext.setQueryParams,
    };
  }, [BoxesUIContext]);

  useEffect(() => {
    const storeKeyWebsite = 'websiteList';
    let listWebsite = undefined;
    if (websiteList !== []) {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (listWebsite) {
        setWebsiteList(JSON.parse(listWebsite));
      } else {
        axios
          .post(PARAM_URL, 'getwebsitelist', {
            headers: { action: 'getwebsitelist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setWebsiteList(response.data.data);
                localStorage.setItem(
                  storeKeyWebsite,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (!listWebsite) {
        localStorage.setItem(storeKeyWebsite, JSON.stringify(websiteList));
      }
      setLoaded(true);
    }

    return function cleanup() {
      setWebsiteList([]);
    };
  }, [loaded]);
  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    //console.log("applyFilter", values);
    const newQueryParams = prepareFilter(BoxesUIProps.queryParams, values);
    //console.log("applyFilter prepareFilter..", newQueryParams);
    if (!isEqual(newQueryParams, BoxesUIProps.queryParams)) {
      //console.log("!isEqual before");
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      //console.log(newQueryParams);
      BoxesUIProps.setQueryParams(newQueryParams);
      //console.log("!isEqual after...", BoxesUIProps.queryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          from: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 90)
            .toISOString()
            .slice(0, 10),
          to: new Date(new Date().getTime() + 1000 * 60 * 60 * 24)
            .toISOString()
            .slice(0, 10),
          websiteCode: '',
          searchText: '',
        }}
        onSubmit={(values) => {
          //console.log("                                         ");
          //console.log("=============== SUBMIT =================");
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    //placeholder="yyyy-mm-dd"
                    type='date'
                    //format="yyyy-mm-dd"
                    className='form-control'
                    placeholder='-с'
                    onBlur={handleBlur}
                    value={values.from}
                    onChange={(e) => {
                      setFieldValue('from', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='ORDER.LABEL.FROM' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    type='date'
                    className='form-control'
                    name='to'
                    onBlur={handleBlur}
                    value={values.to}
                    onChange={(e) => {
                      setFieldValue('to', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='ORDER.LABEL.TO' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='websiteCode'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('websiteCode', e.target.value);
                    handleSubmit();
                  }}
                  value={values.websiteCode}
                >
                  {websiteList.map((option) => (
                    <option
                      key={`websiteList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='status'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('status', e.target.value);
                    handleSubmit();
                  }}
                  value={values.status}
                >
                  {boxStatusList.map((option) => (
                    <option
                      key={`boxstatusList${option.key}`}
                      value={option.key}
                    >
                      {option.value}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-2'>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  placeholder='текстээс хайх'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>

              <div className='col-lg-2'>
                <button
                  id='kt_box_search_submit'
                  type='submit'
                  /* disabled={formik.isSubmitting} */
                  className={`btn btn-primary font-weight-bold `}
                  /* onClick={() => {
                                    //setFieldValue("loading", true);
                                    handleSubmit();
                                }} */
                >
                  <FormattedMessage id='ORDER.LABEL.SEARCH' />
                  {/*   <span><FormattedMessage id="AUTH.LOGIN.BUTTON" /></span> */}
                  {/* {values.loading && <span className="ml-3 spinner spinner-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(BoxesFilter);
